import Heading from 'shopper/components/Heading';

const SiteMapTitle = ({ children }) => (
  <Heading as="h2" className="my-6" size="size4">
    {children}
  </Heading>
);

export default SiteMapTitle;
